import template from './select-control.html';
import controller from './select-control.controller';

import './select-control.styl';

let selectControlComponent = {
  restrict: 'E',
  bindings: {
      model: '=',
      options: '='
  },
  template,
  controller
};

export default selectControlComponent;



// WEBPACK FOOTER //
// ./client/app/common/select-control/select-control.component.js